import React, { useEffect } from "react";
import style from "./BlogDetail.module.css";
import Header from "../../components/Header";
import HeaderMobile from "../../components/HeaderMobile";
import JobShare from "../../components/JobShare";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
// import { Blog1, Blog2, Blog3, Blog4, Blog5, responsibilityIcon } from "../../assets";
// import adminImg from "./admin.png";
import { useQueries, useQuery } from "@tanstack/react-query";
import { getBlogDetail } from "../../api/containersApi";
import truncateIfLong1 from "../../utilities/truncateIfLong1";
import BlogCard from "../../components/BlogCard";
import { ClipLoader } from "react-spinners";


export default function BlogDescription() {

    const blogNavigater = useNavigate();
    const { blogId } = useParams();
    const { data: blogDetail, refetch, isLoading } = useQuery({
        queryKey: ["blogDetail", blogId],
        queryFn: () => (getBlogDetail({auth_key: localStorage.getItem("sessionToken"), blogId: blogId, preview: "1"})),
    });    
    const changeBlogDescription = (blogId) => {
        blogNavigater(`/blogs/blog-detail/${blogId}`);
    }  

    return(

        <div className={style.blogDescription_container}>   

            <HeaderMobile />

            <div className={style.blogDescription_dashboard}>
                <Header />
                {
                    isLoading ? <div style={{height: "80vh", display: "flex", justifyContent: "center", alignItems: "center"}}><ClipLoader color="#FF9900" size={30} speedMultiplier={0.85}/></div> :
                    <div className={style.blogDescription_dashboard_content}>
                        <div className={style.infoBox} data-aos="fade-right">
                            <p title={blogDetail?.author_name}><span>{blogDetail?.author_name}</span><br/>Posted on {blogDetail?.created_at?.split(" at")[0]}</p>
                            <p title={blogDetail?.blog_title}>{truncateIfLong1(blogDetail?.blog_title, 80 )}</p>
                            <p title={blogDetail?.category}>{blogDetail?.category}</p>
                        </div>
                        <div className={style.imageBox} data-aos="fade-left">
                            <div style={{backgroundImage: `url(${blogDetail?.coverImage})`}} className={style.imageBoxBlur}></div>
                            <img src={blogDetail?.coverImage} alt="" />
                        </div>
                    </div>
                }
            </div>

            <div className={style.blogDescription_blog}>
                <section dangerouslySetInnerHTML={{__html: blogDetail?.content}}></section>
                {
                    blogDetail?.similarBlogs?.length > 0 &&
                    <aside>
                        <section className={style.shareSectionTop}>
                            <div style={{fontSize: "18px", margin: "0 0 1rem 0"}}>Share this Blog :</div>
                            <JobShare />
                        </section>
                        <div>Similar Articles</div>
                        {
                            blogDetail?.redNext?.map((record, index) => {   
                                return( 
                                    <BlogCard record={record} makeItSimilarBlog={true} />
                                )
                            })
                        }
                        <section className={style.shareSectionBottom}>
                            <div style={{fontSize: "18px", margin: "0 0 1rem 0"}}>Share this Blog :</div>
                            <JobShare />
                        </section>
                    </aside>
                }   
            </div>

            <div className={style.blogDescription_suggestion}>
                <h1>What To Read Next</h1>
                <div className={style.blogDescription_suggestion_blogs}>
                    {
                        blogDetail?.redNext?.length > 0 ? blogDetail?.redNext?.map((record, index) => {
                            return(
                                <BlogCard record={record} makeItSimilarBlog={false} makeItReadNextBlog={true} />
                            )
                        }) : <div>You are all caught up!</div> 
                    }
                </div>
            
            </div>

        </div>
    );

}